import BaseCommand from "@/models/api/commands/BaseCommand";

export class BankAccountChangeCommand extends BaseCommand {
  CommandName = "BankAccountChange";
  Command: number;
  constructor(sessionId: string, operationId: string, bankAccountId: number) {
    super(sessionId, operationId);
    this.Command = bankAccountId;
  }
}
